import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { uniq } from 'lodash/array';
import remove from 'lodash/remove';
import { fontSize } from '../../../constants/styleConstants';
import Button from '../../../components/Button';
import PerformanceTime from '../../../components/PerformanceCardHeader/PerformanceTime';
import { TP } from '../../../constants/consts';
import { useTranslation } from '../../../src/i18n';
import SubmitModalLayout from '../../../components/SubmitModalLayout';
import TimePicker from '../../../components/Fields/TimePicker';

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(2),
  },
  timeChipsBlock: {
    display: 'flex',
    '& > *': {
      marginRight: theme.spacing(1),
    },
  },
  addTimeBlock: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: theme.spacing(4),
  },
  timePicker: {
    maxWidth: 200,
  },
  addButton: {
    fontSize: fontSize.medium,
    minWidth: 'auto',
    backgroundColor: 'transparent',
    marginLeft: theme.spacing(2),
  },
}));

const StandardizedTime = ({ timeArray, applyStandardTimes, onClose, isOpened }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [times, setTimes] = React.useState(timeArray);
  const [inputTime, setTime] = React.useState('');

  const pushNewStandardTime = () => {
    if (inputTime?.length === 5) {
      setTimes(uniq([...times, inputTime]));
      setTime('');
    }
  };

  const deleteStandardTime = removedTime => {
    const updatedTimes = [...times];
    remove(updatedTimes, timeItem => timeItem === removedTime);
    setTimes(updatedTimes);
  };

  const addTimeEnter = e => {
    if (e?.code === 'Enter') {
      const button = document.getElementById('time_add');
      // as call a func do not take updated state
      if (button) {
        button.click();
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('keyup', addTimeEnter);
    return () => {
      document.removeEventListener('keyup', addTimeEnter);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SubmitModalLayout
      isOpened={isOpened}
      title1={t(`${TP}.FN_STANDARD_PERFORMANCE_TIME`)}
      onClose={onClose}
      footer={
        <Button
          onClick={() => {
            applyStandardTimes(times);
          }}
        >
          {t(`${TP}.FN_APPLY_TO_ALL_PERFORMANCES_STANDARD`)}
        </Button>
      }
    >
      <div className={classes.content}>
        <div className={classes.timeChipsBlock}>
          {times.map(time => (
            <PerformanceTime key={time} active edit time={time} deleteFunc={() => deleteStandardTime(time)} />
          ))}
        </div>
        <div className={classes.addTimeBlock}>
          <TimePicker
            key={inputTime}
            id="performance-time-picker"
            onTimeChange={setTime}
            field={{
              value: inputTime,
              name: 'time',
            }}
            autoFocus
            className={classes.timePicker}
            label={t(`${TP}.FN_ADD_TIME`)}
          />
          <Button className={classes.addButton} variant="outlined" onClick={pushNewStandardTime} id="time_add">
            {t(`${TP}.FN_ADD_TIME_BUTTON`)}
          </Button>
        </div>
      </div>
    </SubmitModalLayout>
  );
};

StandardizedTime.propTypes = {
  timeArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  applyStandardTimes: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
};

export default StandardizedTime;
